export const client_id =
  "794228404967-6dkkl1lt5p7qpak65q0bl1ci1hulg99r.apps.googleusercontent.com";
export const scopes = [
  "openid",
  "email",
  "profile",
  "https://www.googleapis.com/auth/drive",
];
export const maps_api_key = "";
